import { TILE_SIZES } from '@mixtiles/web-backend-shared'
import { getSizeName } from 'services/SizesManager/SizesManagerHelper'
import { type TFunction } from 'i18next'
import { type VideoData } from './CommunitySection'

export const getCommunityVideos = (
  t: TFunction,
  pricingCountry: string
): VideoData[] => {
  return [
    {
      handle: 'beccablas',
      productName: t('homepage.community.subtitle_black_frames', {
        v1: getSizeName({ size: TILE_SIZES.SQUARE_20X20, t, pricingCountry }),
      }),
      name: 'Story - beccablas',
      cldId: 'beccablas',
      folder: 'testimonials/homepage',
    },
    {
      handle: 'codyandbreea',
      productName: t('homepage.community.subtitle_wood_mixed_frames'),
      name: 'Story - codyandbreea',
      cldId: 'codyandbreea',
      folder: 'testimonials/homepage',
    },
    {
      handle: 'chantellemkerr',
      productName: t('homepage.community.subtitle_wood_frames', {
        v1: getSizeName({ size: TILE_SIZES.SQUARE_12X12, t, pricingCountry }),
      }),
      name: 'Story - chantellemkerr',
      cldId: 'chantellemkerr',
      folder: 'testimonials/homepage',
    },
    {
      handle: 'taliyahugc',
      productName: t('homepage.community.subtitle_black_frames', {
        v1: getSizeName({ size: TILE_SIZES.SQUARE_20X20, t, pricingCountry }),
      }),
      name: 'Story - taliyahugc',
      cldId: 'taliyahugc',
      folder: 'testimonials/homepage',
    },
    {
      handle: 'diy.ourhome',
      productName: t('homepage.community.subtitle_wood_frames', {
        v1: getSizeName({ size: TILE_SIZES.SQUARE_20X20, t, pricingCountry }),
      }),
      name: 'Story - diy.ourhome',
      cldId: 'diy.ourhome',
      folder: 'testimonials/homepage',
    },
    {
      handle: 'laurenshandmadehome',
      productName: t('homepage.community.subtitle_white_frames', {
        v1: getSizeName({
          size: TILE_SIZES.RECTANGLE_12X16,
          t,
          pricingCountry,
        }),
      }),
      name: 'Story - laurenshandmadehome',
      cldId: 'laurenshandmadehome',
      folder: 'testimonials/homepage',
    },
    {
      handle: 'sara_strueby',
      productName: t('homepage.community.subtitle_wood_frames', {
        v1: getSizeName({
          size: TILE_SIZES.RECTANGLE_12X16,
          t,
          pricingCountry,
        }),
      }),
      name: 'Story - sara_strueby',
      cldId: 'sara_strueby',
      folder: 'testimonials/homepage',
    },
  ]
}
